import _regeneratorRuntime from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import renderHeadless from './render-headless';
import { RenderType as Type } from 'vega-scenegraph';
import { error } from 'vega-util';
/**
 * Produce an image URL for the visualization. Depending on the type
 * parameter, the generated URL contains data for either a PNG or SVG image.
 * The URL can be used (for example) to download images of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @param {string} type - The image type. One of 'svg', 'png' or 'canvas'.
 *   The 'canvas' and 'png' types are synonyms for a PNG image.
 * @return {Promise} - A promise that resolves to an image URL.
 */

export default function (_x, _x2) {
  return _ref.apply(this, arguments);
}

function _ref() {
  _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(type, scaleFactor) {
    var r;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (type !== Type.Canvas && type !== Type.SVG && type !== Type.PNG) {
              error('Unrecognized image type: ' + type);
            }

            _context.next = 3;
            return renderHeadless(this, type, scaleFactor);

          case 3:
            r = _context.sent;
            return _context.abrupt("return", type === Type.SVG ? toBlobURL(r.svg(), 'image/svg+xml') : r.canvas().toDataURL('image/png'));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _ref.apply(this, arguments);
}

function toBlobURL(data, mime) {
  var blob = new Blob([data], {
    type: mime
  });
  return window.URL.createObjectURL(blob);
}